import Textarea from 'components/ui-kit/Textarea/Textarea';
import { useTranslation } from 'react-i18next';
import { MAX_REVIEW_LENGTH } from 'services/shop-feedback.service';

type ShopFeedbackFormProps = {
  autoFocus?: boolean;
  review: string;
  setReview: (review: string) => void;
  isSubmitting?: boolean;
};

const ShopFeedbackForm = ({ autoFocus = true, review, setReview, isSubmitting }: ShopFeedbackFormProps) => {
  const { t } = useTranslation();

  return (
    <div className="feedback">
      <Textarea
        value={review}
        onChange={setReview}
        placeholder={t('components.feedback.placeholder')}
        maxLength={MAX_REVIEW_LENGTH}
        autoFocus={autoFocus}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default ShopFeedbackForm;
